<template>
    <v-overlay v-bind="$attrs" v-on="$listeners">
        <div class="d-flex flex-column align-center">
            <v-progress-circular color="white" indeterminate />
            <div class="ml-1">{{ text }}</div>
        </div>
    </v-overlay>
</template>

<script>
import { getI18nInstance as i18n } from '@/i18n';

export default {
    props: {
        text: {
            type: String,
            default: () => i18n().t('loading'),
        },
    },
};
</script>
